export default __webpack_public_path__ + "static/media/uploader-tandem-problem-1.8ac939e5.png";